import React, { useState } from "react";
import qs from "qs";
import getId from "../../../../utils/getId";
import { useLocation } from "react-router";
import { format } from "date-fns";
import "./style.css";
import useDesktopSize from "../../../../utils/hooks/useDesktopSize";
import MovieGallery from "./MovieGallery";
import MovieTrailers from "./MovieTrailers";
import SeansList from "./SeansList";
import { useSelector } from "react-redux";
import { State } from "../../../store";
import { useTranslation } from "react-i18next";

const MovieDetails: React.FC = () => {
  const location = useLocation();
  const isDesktop = useDesktopSize();
  const movieIds = qs.parse(location.search.slice(1)).ids as string;
  const movie = useSelector((state: State) => state.shows.shows).find((value) => getId(value) === movieIds);
  const [activeTab, setActiveTab] = useState(0);
  const { t } = useTranslation();
  return (
    <div className={isDesktop ? "panel-movie-details" : "panel-movie-details-mobile"}>
      <div className={"movie-poster"} style={{ backgroundImage: `url(${movie?.moviePicture})` }}></div>
      <div className={"movie-description"}>
        <h3 id={"movie-title"}>{movie?.name}</h3>
        <p id={"movie-en-name"}>{movie?.englishName}</p>
        <p id={"movie-type"}>{`${movie?.type} | ${movie?.duration}`}</p>
        <p>
          <strong>{t("rezyseria")}:</strong> {movie?.director}
        </p>
        <p>
          <strong>{t("obsada")}:</strong> {movie?.cast}
        </p>
        <p></p>
        <p id={"movie-desc"}>
          <strong>{t("opis")}:</strong>
          <span>{movie?.description}</span>
        </p>

        <div className={"movie-seanse"}>
          <h3>
            <span>{t("najblizsze_seanse_na_dzien")}:</span>{" "}
            {format(movie ? new Date(movie.exercises[0].startTime) : new Date(), "dd-MM-yyyy")}
          </h3>
          <SeansList exerciseList={movie ? movie.exercises : []} />
        </div>
      </div>

      <div className={"movie-multimedia"}>
        <div className={"movie-multimedia-btn"}>
          <button className={activeTab === 0 ? "active" : ""} onClick={() => setActiveTab(0)}>
            {t("zdjecia")}
          </button>
        </div>

        <div className={"movie-multimedia-btn"}>
          <button className={activeTab === 1 ? "active" : ""} onClick={() => setActiveTab(1)}>
            {t("zwiastuny")}
          </button>
        </div>
        {activeTab === 0 && (
          <div className={"movie-photos"}>
            <MovieGallery gallery={movie ? movie.gallery : []} />
          </div>
        )}
        {activeTab === 1 && (
          <div className={"movie-trailers"}>
            <MovieTrailers trailers={movie ? movie.trailers : []} />
          </div>
        )}
      </div>
    </div>
  );
};

export default MovieDetails;
